export const GET_TASKS_REQUEST = 'task/get_tasks_request'
export const ALUMNO_GET_TASKS_REQUEST = 'task/alumno_get_tasks_request'
export const ALUMNO_GET_TASK_REQUEST = 'task/alumno_get_task_request'
export const ALUMNO_MARK_DONE = 'task/alumno_mark_done'
export const GET_TASK = 'task/get_task'
export const GET_TASKS = 'task/get_tasks'
export const ADD_TASK = 'task/add_task'
export const DELETE_TASK = 'task/delete_task'
export const EDIT_TASK = 'task/edit_task'
export const TASK_FAIL = 'task/fail'
export const CORREGIR_TASK = 'task/corregir_task'
export const CLEAN_STORE = 'task/clean_store'
